// Multivariate dependencies
import React from 'react';
/**
 * Renders toolbar items from the config object
 *
 * @deprecated Do not use legacy components anymore.
 * @param {Record<string, React.ComponentType>} toolBarItems props
 *
 * @returns {React.ComponentType[]} - array of toolbar items
 */
export var renderToolBarItems = function (toolBarItems) {
    return toolBarItems.map(function (_a) {
        var id = _a.id, ToolbarItem = _a.component, showItem = _a.showItem;
        return showItem && React.createElement(ToolbarItem, { key: id });
    });
};
//# sourceMappingURL=renderToolBarItems.js.map